import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import Btn from "../components/Btn/Btn";
import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery = () => {
  return (
    <React.Fragment>
      <SEO title="Scenery | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
          <div className="ch-lang-en">
          <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/scenery_zn"}>Chinese</Link>
          </div>
          <div className="space-50"></div>
          <h2>Attractions in Xi&apos;an</h2>
          <p align="justify">
            <b>
              Xi&apos;an was known as &quot;Chang&apos;an&quot; and
              &quot;Jingzhao&quot; in ancient times. It was hailed as &quot;A
              Golden City, a Kingdom of Abundance&quot; in historical records.
              It is one of the world-famous four ancient capitals in the world.
              Xi&apos;an has unique tourism resources and is one of the famous
              historical and cultural cities over the world. Xi&apos;an is one
              of the important cradles of ancient Chinese civilization, with a
              3000-year history of building a city; 13 dynasties have
              established their capitals in Xi&apos;an. It used to be the center
              of Chinese politics, economy, and culture, the capital of the Han
              Dynasty, and the birthplace of Han culture. The &quot;Silk
              Road&quot; started from Chang&apos;an at that time and Xi&apos;an
              at present. Xi&apos;an is a world-famous historical capital on par
              with Athens, Rome, and Cairo. In 1981, UNESCO awarded Xi&apos;an
              the title of &quot;World Historic City&quot;.
              <br />
              <br />
              Xi&apos;an is extremely rich in cultural heritage. There are 34
              national key cultural relics protection units in Xi&apos;an City,
              72 cultural relics protection units in Shaanxi Province, and 176
              city and county-level key cultural relics protection units. 
              Xi&apos;an is one of the first regions to be awarded the title of
              &quot;China&apos;s Excellent Tourism City&quot;. Tourism is the
              pillar industry of Xi&apos;an&apos;s economic development and the
              main source of non-foreign foreign exchange earnings. Xi&apos;an is the
              birthplace of Chinese and Han culture, the ancient capital of the
              Western Zhou Dynasty, the beacon tower of Zhouyou Wang&apos;s Fenghuo
              opera princes, the Han Chang&apos;an City, the Han Palace ruins, the
              Han Emperor Liu Bang Chang Tomb, Han Jing Emperor Yang Tomb, and
              many other Han kings, Han Wu Emperor Maoling, Wu Queen of Zhou Wu
              Zetian Qian Mausoleum and many Han tombs. The place where the
              Xi&apos;an Incident took place. In addition, Xi&apos;an also has
              famous natural scenic spots such as the Zhongnan Mountains, as
              well as the &quot;Eight Sceneries of Chang&apos;an&quot; handed
              down in ancient times.
              <br />
            </b>
            <br />
          </p>

          <li>
            <a href="#bingmayong">Emperor Qinshihuang&apos;s Mausoleum Site Museum</a>
          </li>
          <li>
            <a href="#huaqing">Huaqing Pool</a>
          </li>
          <li>
            <a href="#dayanta">Dayan Pagoda·Tang Paradise</a>
          </li>
          <li>
            <a href="#daminggong">Daming Palace National Heritage Park</a>
          </li>
          <li>
            <a href="#chengqiang">Xi&apos;an City Wall·Stele Forest Historical and Cultural Scenic Spot</a>
          </li>
          <li>
            <a href="#zhonggulou">Xi&apos;an Bell and Drum Tower</a>
          </li>
          <li>
            <a href="#chenghuangmiao">Xi&apos;an City God Temple</a>
          </li>
          <br />
          <h4 id="bingbayong">Emperor Qinshihuang&apos;s Mausoleum Site Museum</h4>
          <p align="justify">
          The Emperor Qinshihuang&apos;s Mausoleum Site Museum is located in Qin Shihuang&apos;s Mausoleum, Xi&apos;an, Shaanxi Province. It was established in 1975. It is a cultural museum based on the statue of Qin Shihuang&apos;s horse. Horse statue. The world bee, the excavation of the terracotta warriors and horses, is a world archeological wonder, the greatest discovery in the history of the twentieth century. The statue of Qin Shi Huangma has three pits No. 1, 2 and 3, where a large number of pottery figurines, horses, sculpture weapons, etc. are buried.
          </p>
          <p>
            <img
              src="./images/xian/sc1.jpg"
              alt="秦始皇兵马俑博物馆"
              width="100%"
            />
          </p>

          <h4 id="huaqing">Huaqing Pool</h4>
          <p align="justify">
          Xi&apos;an Huaqing Pool Scenic Area is located 30 kilometers east of Xi&apos;an. In January 2015, it merged with the two major scenic spots &quot;Lishan&quot; and upgraded to Huaqing Palace. It is a landmark scenic spot for cultural tourism in the Tang Dynasty in China, a national key scenic spot, and a national key cultural relics protection unit. , National Cultural Industry Demonstration Base. Within the Huaqing Palace are cultural areas such as the Tang Yutang Relic Museum, the former site of the Xi&apos;an Incident-Wujian Hall, the Tangliyuan Relic Museum and other landmark buildings such as Feishuang Hall, Huanyuan and Yuwang Hall. Lishan is 1,302 meters above sea level, and there are many scenic spots such as Laomu Hall, Laojun Hall, Beacon Tower, Yuxian Bridge, etc. The &quot;Evening Photos of Lishan Mountain&quot; is one of the famous &quot;Eight Scenic Spots in Guanzhong&quot;.
          </p>
          <p>
            <img
              src="./images/xian/sc2.jpg"
              alt="西安市华清池景区"
              width="100%"
            />
            <br />
          </p>

          <h4 id="dayanta">Dayan Pagoda · Tang Paradise </h4>
          <p align="justify">
          The Dayan Pagoda·Tang Paradise scenic spot in Xi&apos;an, Shaanxi includes two tourist areas, the Dayan Pagoda and the Tang Paradise. A large-scale royal garden-style cultural theme park with Tang style, covering an area of 1,000 acres, of which the water area is 300 acres. The Big Wild Goose Pagoda is located in the Dacien Temple in the south of Xi&apos;an, Shaanxi Province. It is also known as the &quot;Pagoda of Ci&apos;en Temple&quot;. The construction of the Dayan Pagoda is the result of the pagoda, an architectural form of ancient Indian Buddhism, being introduced to China along with the spread of Buddhism.
          </p>
          <p>
            <img src="./images/xian/sc3.jpg" alt="陕西西安大雁塔" width="100%" />
            <img src="./images/xian/sc4.jpg" alt="大唐芙蓉园景区" width="100%" />
            <br />
          </p>

          <h4 id="daminggong">Daming Palace National Heritage Park </h4>
          <p align="justify">
          Daming Palace National Heritage Park is located on Taihua South Road, Xi&apos;an City, Shaanxi Province. Daming Palace is located on the Longshou Plain in the north of Chang&apos;an City. The Daming Palace of Tang Dynasty covers an area of 3.5 square kilometers, and its area is equivalent to 3 Versailles, 4.5 Forbidden City, 12 Kremlin, 13 Louvre, 15 Buckingham Palace, which fully demonstrates the majestic style of palace architecture in Tang Dynasty. The Daming Palace site is the first batch of national key cultural relics protection units announced by the State Council in 1961. It is a major site protection project of world significance determined by the International Council of Ancient Ruins, and is an important part of the Silk Road as a whole to apply for world cultural heritage.
          </p>

          <p>
            <img
              src="./images/xian/sc5.jpg"
              alt="大明宫国家遗址公园"
              width="100%"
            />
            <br />
          </p>

          <h4 id="chengqiang">Xi&apos;an City Wall · Stele Forest Historical and Cultural Scenic Spot</h4>
          <p align="justify">
          The City Wall·Stele Forest Historical and Cultural Scenic Spot is composed of the most influential Stele Forest Museum and City Wall Scenic Spot in Xi&apos;an. The Xi&apos;an Stele Forest Museum is adjacent to Shuyuanmen Cultural Street, and is world-famous for its collection, display and research of ancient stele inscriptions, epitaphs and stone inscriptions. Xi&apos;an City Wall, the oldest and most well-preserved ancient city wall building in the world, continues the historical context of the entire ancient capital of Chang&apos;an, and shows its magnificence, magnificence and breadth to the world with its unique charm. The depth, wisdom and inclusiveness of the ancient capital.
          </p>
          <p>
            <img src="./images/xian/sc6.jpg" alt="西安城墙景区" width="100%" />
            <img
              src="./images/xian/sc7.jpg"
              alt="碑林历史文化景区"
              width="100%"
            />
            <br />
          </p>

          <h4 id="zhonggulou">Xi&apos;an Bell and Drum Tower</h4>
          <p>Xi&apos;an Bell and Drum Tower is the collective name of Xi&apos;an Bell Tower and Xi&apos;an Drum Tower. Located in the center of Xi&apos;an, it is a landmark building in Xi&apos;an. The two Ming Dynasty buildings echo each other and are spectacular. Xi&apos;an Bell Tower was built in the 17th year of Hongwu in the Ming Dynasty (AD 1384). It was originally built on the east side of Guangji Street, North Guangji Street, West Street. The bell tower is a loft-style building with double eaves, three drops of water and four corners and spires, covering an area of 1377.64 square meters, built on a square base made of blue bricks and white ash. There is a cross-shaped voucher hole with a height and width of 6 meters under the base, which communicates with the four streets in the south, east, north, and west. Xi&apos;an Drum Tower was built in the thirteenth year of Hongwu in the Ming Dynasty (AD 1380), which was earlier than the construction of the Bell Tower.
          </p>
          <p>
            <img src="./images/xian/sc8.jpg" alt="西安钟鼓楼" width="100%" />
            <br />
          </p>

          <h4 id="chenghuangmiao">Xi&apos;an City God Temple </h4>
          <p align="justify">
          Xi&apos;an City&apos;s God Temple is one of the three &quot;City&apos;s God Temples” in the world, and is as famous as Beijing and Nanjing City&apos;s God Temples. The original main buildings include the gate, the Jade Emperor Pavilion, the Lewu Building, the archway, the main hall, the road house, the wing, etc., but most of them were destroyed afterwards. There is only one rebuilt main hall in the first year of Yongzheng in the Qing Dynasty (1723).Covered with glazed tiles, the front eaves and doors and windows are embossed with various patterns and patterns. The carvings are fine and the patterns are exquisite. The original plastics in the hall have statues of city gods, judges, and little ghosts. In front of the archway outside the temple, there was a pair of standing bronze lions, both of which were cast in the 38th year of Jiajing in Ming Dynasty (1559), and are now located outside the gate of the Shaanxi Provincial Museum. The temple is a famous ancient Taoist temple in Xi&apos;an and a gathering place for merchants and hundreds of craftsmanship. On June 25, 2001, as an ancient building in the Ming and Qing dynasties, Xi&apos;an City God Temple was approved by the State Council to be included in the fifth batch of national key cultural relics protection units.
          </p>
          <p>
            <img src="./images/xian/sc9.jpg" alt="西安城隍庙" width="100%" />
            <br />
          </p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery;
